const pageNameKey = "blueprintStateInfoBannerBlueprintNameVerifiedWrapper";

export const blueprintStateInfoBannerBlueprintNameVerifiedWrapperEn = {
  [pageNameKey]: {
    whiteCheckBadgeIconAltText: "White Check Badge Icon",
  },
};

export const blueprintStateInfoBannerBlueprintNameVerifiedWrapperPtBr = {
  [pageNameKey]: {
    whiteCheckBadgeIconAltText: "Ícone de selo de verificação branco",
  },
};

export const blueprintStateInfoBannerBlueprintNameVerifiedWrapperDe = {
  [pageNameKey]: {
    whiteCheckBadgeIconAltText: "Weißes Check Icon",
  },
};

export const blueprintStateInfoBannerBlueprintNameVerifiedWrapperZhHans = {
  [pageNameKey]: {
    whiteCheckBadgeIconAltText: "白色勾选徽章图标",
  },
};

export const blueprintStateInfoBannerBlueprintNameVerifiedWrapperIt = {
  [pageNameKey]: {
    whiteCheckBadgeIconAltText: "Icona bianca del badge di controllo",
  },
};

export const blueprintStateInfoBannerBlueprintNameVerifiedWrapperEs = {
  [pageNameKey]: {
    whiteCheckBadgeIconAltText:
      "Icono de insignia de marca de verificación blanca",
  },
};

export const blueprintStateInfoBannerBlueprintNameVerifiedWrapperNl = {
  [pageNameKey]: {
    whiteCheckBadgeIconAltText: "Wit vinkje-pictogram",
  },
};

export const blueprintStateInfoBannerBlueprintNameVerifiedWrapperTr = {
  [pageNameKey]: {
    whiteCheckBadgeIconAltText: "Beyaz Onay Rozeti Simgesi",
  },
};
